import React from 'react';
import Select from 'react-select';
import classnames from 'classnames'
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { selectDefaultStyles } from '../../../styling/selectDefaultStyles';
import { withLocalize, Translate } from 'react-localize-redux';
import { toast } from '../../../common/toast';
import { writeErr } from '../../../common/logger';
import { popupActions } from '../../../../store/popupStore';
import { domainActions } from '../../../../store/domainStore';
import { windowActions } from '../../../../store/windowStore';
import { addContractSchema } from '../../validations/addContractSchema';
import { isNullOrUndefined, isEmpty } from '../../../../store/storeFunctions';
import { apiGet, apiPost, getHostApi } from '../../../../store/apiWrapper';
import { repiDomainNotInitilized, reportUrlChanged } from '../../repiUtils';
import { repiActions, repiDomain, repiAddContractFields, repiContractFields } from '../../../../store/repiStore';
import TabLink from '../../../search/tabLink';
import Message from '../../../common/message';
import FormMenuControl from '../../../common/formMenuControl'
import RepiSearchInput from '../../search/repiSearchInput';
import BbFormikCheckbox from '../../../styling/bbFormikCheckbox';

import './repiAddContractForm.scss';

const TYPES = [
    { id: 1, label: "Repi.DataCorrection.AddContract.Loans",  name: "loans" },
    { id: 3, label: "Repi.DataCorrection.AddContract.Others", name: "others" },
    { id: 2, label: "Repi.DataCorrection.AddContract.ClaimEnforcements",  name: "claims" }
];

class RepiAddContractForm extends React.Component {
    state = {
        productCategory: 1,
        checkRequesting: false,
        checkFailed: false,
        checkDone: false,
        requesting: false,
        checkingData: false,
        contractExists: false,
        checkError: false,
        validationErrors: [],
        validationWarnings: [],
        postingData: false,
    };

    get subjectId() {
        return get(this.props, "computedMatch.params.id");
    }

    render() {
        return (
            <Formik
                enableReinitialize={true}
                initialValues={this.getInitialValues()}
                validateOnChange={true}
                validationSchema={addContractSchema(this.props.translate, this.state.productCategory)}
                onSubmit={(values, { setSubmitting }) => this.handleSubmit(values, setSubmitting)}
            >
                {({ values, errors, touched, isSubmitting, setFieldValue }) => <Form>
                    <div className="columns is-desktop">
                        <div className="column is-4-desktop tabs tabs-form-menu repi-add-contract-product-tabs">
                            <FormMenuControl>
                                <ul>
                                    {TYPES.map((t, i) => <TabLink
                                        key={t.id}
                                        type={t.id}
                                        selected={this.state.productCategory}
                                        onSelect={(value) => this.selectSearch(value)}
                                        icon={this.getIconBySubjectType(t.id)}
                                        titleKey={t.label}
                                        descriptionKey={`${t.label}.Description`}
                                        hr={i < (TYPES.length - 1)}
                                    />)}
                                </ul>
                            </FormMenuControl>
                        </div>
                        <div className="column">
                            <div className="card card-special" style={{ paddingTop: "1.5em" }}>
                                <div className="card-body">
                                    {this.renderWarning()}
                                    {this.renderContractForm({ values, errors, touched, isSubmitting, setFieldValue })}
                                    <button id="btn-submit-form"
                                        type="submit"
                                        style={{ display: "none" }}
                                        disabled={this.state.requesting === true || Object.keys(errors).length > 0}
                                    />
                                    <div style={{ textAlign: "center", marginTop: "2em" }}>
                                        {this.renderButtons(this.state.requesting === true || Object.keys(errors).length > 0)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>}
            </Formik>
        );
    }

    componentDidMount() {
        this.props.ensureDomainData(repiDomain.products);
        this.props.ensureDomainData(repiDomain.currencies);
        this.props.ensureDomainData(repiDomain.dunningLevels);
    }

    componentDidUpdate(prevProps) {
        if (reportUrlChanged(prevProps, this.props)) {
            this.getSubjectData();
        }

        if (!this.state.checkRequesting && this.state.checkFailed === false && this.state.checkDone === false) {
            this.getSubjectData();
        }

        if (this.props.userLaguage !== prevProps.userLaguage) {
            this.props.ensureDomainData(repiDomain.products);
            this.props.ensureDomainData(repiDomain.currencies);
            this.props.ensureDomainData(repiDomain.dunningLevels);
        }
    }

    renderContractForm = (formik) => {
        if (this.state.checkFailed)
            return null;

        switch (this.state.productCategory) {
            case 1: return this.renderContractFormLoans(formik);
            case 2: return this.renderContractFormClaims(formik);
            case 3: return this.renderContractFormOthers(formik);
            default: return null;
        }
    }

    renderContractFormLoans = (formik) => {
        const suffix = formik.values.product == 12 || formik.values.product == 13 ? "CreditCard" : "ConsumerLoan";

        return (
            <div className="columns is-multiline">
                <Input name={repiAddContractFields.contributorContractId} label={this.props.translate("Repi.Other.ContributorContractId")} formik={formik} isRequired />
                {this.renderSelect(repiAddContractFields.product, this.props.translate("Repi.DataCorrection.AddContract.Product"), formik, this.getProductSelectOptions())}
                {this.renderSelect(repiAddContractFields.currency, this.props.translate("Repi.Report.PaymentHistory.Currency"),
                    formik, this.getCurrencySelectOptions())}
                <Input name={repiAddContractFields.totalAmount} label={this.props.translate(`Repi.Report.PaymentHistory.Contract.TotalAmount.${suffix}`)}
                    formik={formik} />
                <Input name={repiAddContractFields.remainingAmount} label={this.props.translate(`Repi.Report.PaymentHistory.Contract.RemainingAmount.${suffix}`)}
                    formik={formik} isRequired />
                <Input name={repiAddContractFields.overdueAmount} label={this.props.translate("Repi.Report.PaymentHistory.Contract.OverdueAmount")}
                    formik={formik} isRequired />
                {this.renderSelect(repiAddContractFields.dunningLevel, this.props.translate("Repi.Report.PaymentHistory.DunningLevel"),
                    formik, this.getDunningLevelSelectOptions(), false)}
                <Input name={repiAddContractFields.debtBuyerId} label={this.props.translate("Repi.Report.PaymentHistory.DebtBuyerId")} formik={formik} />
                <Input name={repiAddContractFields.startDate} label={this.props.translate("Repi.Report.PaymentHistory.StartDate")} formik={formik} isDate noMaxDate />
                <Input name={repiAddContractFields.endDate} label={this.props.translate("Repi.Report.PaymentHistory.EndDate")} formik={formik} isDate noMaxDate />
                {this.renderCheckbox(repiAddContractFields.isContractOpen, this.props.translate("Repi.DataCorrection.AddContract.IsContractOpen"))}
            </div>
        );
    }

    renderContractFormClaims = (formik) => {
        return (
            <div className="columns is-multiline">
                <Input name={repiAddContractFields.contributorContractId} label={this.props.translate("Repi.Other.ContributorContractId")} formik={formik} isRequired />
                {this.renderSelect(repiAddContractFields.product, this.props.translate("Repi.DataCorrection.AddContract.Product"), formik, this.getProductSelectOptions())}
                {this.renderSelect(repiAddContractFields.currency, this.props.translate("Repi.Report.PaymentHistory.Currency"),
                    formik, this.getCurrencySelectOptions())}
                <Input name={repiAddContractFields.totalAmount} label={this.props.translate("Repi.Report.PaymentHistory.Contract.TotalAmount.ClaimEnforcement")}
                    formik={formik} />
                <Input name={repiAddContractFields.remainingAmount} label={this.props.translate("Repi.Report.PaymentHistory.Contract.RemainingAmount.ClaimEnforcement")}
                    formik={formik} isRequired />
                <Input name={repiAddContractFields.overdueAmount} label={this.props.translate("Repi.Report.PaymentHistory.Contract.OverdueAmount")}
                    formik={formik} isRequired />
                {this.renderSelect(repiAddContractFields.dunningLevel, this.props.translate("Repi.Report.PaymentHistory.DunningLevel"),
                    formik, this.getDunningLevelSelectOptions(), false)}
                <Input name={repiAddContractFields.debtBuyerId} label={this.props.translate("Repi.Report.PaymentHistory.DebtBuyerId")} formik={formik} />
                <Input name={repiAddContractFields.startDate} label={this.props.translate("Repi.Report.PaymentHistory.StartDate")} formik={formik} isDate noMaxDate />
                <Input name={repiAddContractFields.endDate} label={this.props.translate("Repi.Report.PaymentHistory.EndDate")} formik={formik} isDate noMaxDate />
                <Input name={repiAddContractFields.creditorId} label={this.props.translate("Repi.DataCorrection.AddContract.CreditorId")} formik={formik} />
                <Input name={repiAddContractFields.recallDate} label={this.props.translate("Repi.Report.PaymentHistory.RecallDate")} formik={formik} isDate />
                {this.renderSelect(repiAddContractFields.productOriginal, this.props.translate("Repi.Report.PaymentHistory.ProductOriginal"),
                    formik, this.getProductOriginalSelectOptions(), false)}
                <div className="column is-6" />
                {this.renderCheckbox(repiAddContractFields.isContractOpen, this.props.translate("Repi.DataCorrection.AddContract.IsContractOpen"))}
            </div>
        );
    }

    renderContractFormOthers = (formik) => {
        return (
            <div className="columns is-multiline">
                <Input name={repiAddContractFields.contributorContractId} label={this.props.translate("Repi.Other.ContributorContractId")} formik={formik} isRequired />
                {this.renderSelect(repiAddContractFields.product, this.props.translate("Repi.DataCorrection.AddContract.Product"), formik, this.getProductSelectOptions())}
                {this.renderSelect(repiAddContractFields.currency, this.props.translate("Repi.Report.PaymentHistory.Currency"),
                    formik, this.getCurrencySelectOptions())}
                {this.renderSelect(repiAddContractFields.dunningLevel, this.props.translate("Repi.Report.PaymentHistory.DunningLevel"),
                    formik, this.getDunningLevelSelectOptions(), false)}
                <Input name={repiAddContractFields.totalAmount} label={this.props.translate("Repi.Report.PaymentHistory.Contract.TotalAmount.RegularPayment")}
                    formik={formik} />
                <Input name={repiAddContractFields.overdueAmount} label={this.props.translate("Repi.Report.PaymentHistory.Contract.OverdueAmount")}
                    formik={formik} isRequired />
                <Input name={repiAddContractFields.debtBuyerId} label={this.props.translate("Repi.Report.PaymentHistory.DebtBuyerId")} formik={formik} />
                <div className="column is-6" />
                <Input name={repiAddContractFields.startDate} label={this.props.translate("Repi.Report.PaymentHistory.StartDate")} formik={formik} isDate noMaxDate />
                <Input name={repiAddContractFields.endDate} label={this.props.translate("Repi.Report.PaymentHistory.EndDate")} formik={formik} isDate noMaxDate />
                {this.renderCheckbox(repiAddContractFields.isContractOpen, this.props.translate("Repi.DataCorrection.AddContract.IsContractOpen"))}
            </div>
        );
    }

    renderButtons = (submitDisabled) => {
        if (this.state.checkFailed)
            return null;

        return (
            <button type="submit" disabled={submitDisabled}
                className={classnames("bb-button gradient-1", {"is-square": localStorage.locales_button_style === "square" })}
            >
                {this.state.requesting === true || this.state.checkingData === true
                    ? <FontAwesomeIcon icon="cog" spin />
                    : <Translate id="Repi.DataCorrection.AddContract" />}
            </button>
        );
    }

    renderWarning = () => {
        if (this.state.checkFailed || this.state.checkError || this.state.contractExists) {
            return (
                <Warning type="error">
                    <span>{this.props.translate(this.getErrorMessageByState())}</span>
                </Warning>
            );
        }

        const noErrors = isNullOrUndefined(this.state.validationErrors) || this.state.validationErrors.length === 0;
        const noWarnings = isNullOrUndefined(this.state.validationWarnings) || this.state.validationWarnings.length === 0;

        if (noErrors && noWarnings)
            return null;

        const type = noErrors ? "warning" : "error";
        const message = this.props.translate(`Repi.DataCorrection.AddSubject.Validation.${(noErrors ? "Warnings" : "Errors")}`);
        const detail = this.props.translate("Repi.DataCorrection.AddSubject.Validation.Details");

        return (
            <Warning type={type}>
                <span>{message}. <a className="link-functional" onClick={() => this.displayValidationDetails()}>{detail}</a></span>
            </Warning>
        );
    }

    renderSelect = (name, label, formik, options, isRequired = true) => {
        options = Array.isArray(options) ? options : [];
        const current = options.find(o => o.value === formik.values[name]);

        return (
            <div className="column is-6">
                <div className="repi-search-input-row repi-search-flex">
                    <div className="field bb-field" style={{ marginBottom: "0px" }}>
                        <label>{label}</label>{isRequired ? <span className="repi-search-input-star"> *</span> : null}
                        <Select
                            className="repi-data-correction-select"
                            closeMenuOnSelect={true}
                            field={name}
                            value={current}
                            styles={selectDefaultStyles}
                            isSearchable={false}
                            options={options}
                            hideSelectedOptions={false}
                            allowSelectAll={false}
                            onChange={(v) => formik.setFieldValue(name, v.value)}
                            placeholder=""
                            formatOptionLabel={({ value, label }) => (
                                <div style={{ display: "flex" }}>
                                    <span style={{minHeight: "1em", textAlign: "left", fontSize: "0.75em", whiteSpace: "nowrap" }} type={value} size="medium">
                                        {label}
                                    </span>
                                </div>
                            )}
                        />
                    </div>
                </div>
            </div>
        )
    }

    renderCheckbox = (name, label) => {
        return (
            <div className="column is-6">
                <div className="repi-search-input-row repi-search-flex">
                    <div className="field bb-field" style={{ marginBottom: "0px" }}>
                        <label style={{ visibility: "hidden" }}>A</label>
                        <div className="control repi-search-consent-wrapper">
                            <BbFormikCheckbox label={label} name={name} id={`chb-${name}`} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    getInitialValues = () => {
        return {
            [repiAddContractFields.contributorContractId]: "",
            [repiAddContractFields.product]: this.state.productCategory === 1 ? 1 : this.state.productCategory === 2 ? 11 : 3,
            [repiAddContractFields.currency]: "CZK",
            [repiAddContractFields.totalAmount]: "",
            [repiAddContractFields.remainingAmount]: "",
            [repiAddContractFields.overdueAmount]: "",
            [repiAddContractFields.isContractOpen]: true,
            [repiAddContractFields.dunningLevel]: 0,
            [repiAddContractFields.debtBuyerId]: "",
            [repiAddContractFields.startDate]: "",
            [repiAddContractFields.endDate]: "",
            [repiAddContractFields.creditorId]: "",
            [repiAddContractFields.productOriginal]: "",
            [repiAddContractFields.recallDate]: ""
        };
    }

    handleSubmit = (values, setSubmitting) => {
        this.setState(
            { validationErrors: [], validationWarnings: [], checkingData: true, contractExists: false, checkError: false },
            () => this.postCheckData(values, setSubmitting)
        );
    }

    postCheckData = (values, setSubmitting) => {
        const data = { subjectId: parseInt(this.subjectId) };
        Object.keys(values).forEach(k => {
            if (isEmpty(values[k]) || this.shouldFilterValueByProductCategory(this.state.productCategory, k))
                data[k] = null;
            else {
                if ([repiAddContractFields.remainingAmount, repiAddContractFields.totalAmount, repiContractFields.overdueAmount].includes(k))
                    data[k] = Number(values[k]);
                else if (k === repiAddContractFields.dunningLevel && values[k] === 0)
                    data[k] = null;
                else
                    data[k] = values[k];
            }
        });

        apiPost(getHostApi() + "/api/repi/contract/check", null, data,
            (s) => {
                if (!s.hasData || isNullOrUndefined(s.data) || isNullOrUndefined(s.data.validationResult)) {
                    toast(this.props.translate("Repi.DataCorrection.AddSubject.Fail"), "error");
                    writeErr("No data returned from /api/repi/contract/check");
                    this.props.close();
                    return;
                }

                if (s.data.contractExists) {
                    this.setState({ contractExists: true });
                } else {
                    this.setState({
                        validationErrors: s.data.validationResult.errors,
                        validationWarnings: s.data.validationResult.warnings
                    });
                    if (s.data.validationResult.isValid === true)
                        this.postContract(data);
                }
            },
            (e) => {
                this.setState({ checkError: true });
                writeErr(e);
            },
            () => this.setState({ checkingData: false })
        );

        setSubmitting(false);
    }

    postContract = (data) => {
        this.setState({ postingData: true });
        apiPost(getHostApi() + "/api/repi/contract/add", null, data,
            (s) => {
                if (!s.hasData || s.data !== true) {
                    toast(this.props.translate("Repi.DataCorrection.AddContract.Fail"), "error");
                    writeErr("No data returned from /api/repi/contract/add");
                    return;
                }
                toast(this.props.translate("Repi.DataCorrection.AddContract.Success"), "info");
            },
            (e) => {
                toast(this.props.translate("Repi.DataCorrection.AddContract.Fail"), "error");
                writeErr(e);
            },
            () => {
                this.setState({ postingData: false });
            }
        );
    }

    selectSearch = (selected) => {
        if (selected !== this.state.productCategory) {
            this.setState({ productCategory: selected });
            this.props.closeAll();
        }
    }

    getIconBySubjectType = (st) => {
        switch (st) {
            case 1: return <FontAwesomeIcon icon="credit-card" className="tabs-icon" />;
            case 2: return <FontAwesomeIcon icon="landmark" className="tabs-icon" />;
            case 3: return <FontAwesomeIcon icon="file-invoice" className="tabs-icon" />;
            default: return null;
        }
    }

    getSubjectData = () => {
        this.setState({ checkRequesting: true });
        apiGet(`${getHostApi()}/api/repi/${this.subjectId}/add-contract-check`, null,
            (s) => {
                if (isNullOrUndefined(s) || !s.hasData || s.data !== true)
                    this.setState({ checkFailed: true });
                else
                    this.setState({ checkFailed: false });
            },
            (e) => {
                writeErr(e);
                this.setState({ checkFailed: true });
            },
            (_) => this.setState({ checkRequesting: false, checkDone: true })
        );
    }

    getProductSelectOptions = () => {
        const domain = this.props.domain;
        if (repiDomainNotInitilized(domain, repiDomain.products))
            return [];

        const allProducts = domain[repiDomain.products].requestResult;
        let filteredProducts = [];
        if (this.state.productCategory === 1) {
            // ConsumerLoan, Leasing, RevolvingLoan, CreditCard
            filteredProducts = allProducts.filter(f => [1, 10, 12, 13].includes(parseInt(f.value)))
        } else if (this.state.productCategory === 2) {
            // ClaimEnforcement
            filteredProducts = allProducts.filter(f => [11].includes(parseInt(f.value)))
        } else {
            // All other products
            filteredProducts = allProducts.filter(f => ![1, 6, 7, 8, 9, 10, 11, 12, 13, 14].includes(parseInt(f.value)))
        }

        return filteredProducts.map(p => ({
            value: parseInt(p.value),
            label: this.props.translate(`Repi.ProductType.${p.value}`),
            code: p.shortening
        })).sort((a, b) => (a.value > b.value) ? 1 : -1);
    }

    getDunningLevelSelectOptions = () => {
        const domain = this.props.domain;
        if (repiDomainNotInitilized(domain, repiDomain.dunningLevels))
            return [];

        const allDunningLevels = [
            { value: "0", shortening: "" },
            ...domain[repiDomain.dunningLevels].requestResult
        ];

        return allDunningLevels.map(d => ({
            value: parseInt(d.value),
            label: d.value === "0" ? "" : this.props.translate(`Repi.DunningLevel.${d.value}`),
            code: d.shortening
        })).sort((a, b) => (a.value > b.value) ? 1 : -1);
    }

    getProductOriginalSelectOptions = () => {
        const domain = this.props.domain;
        if (repiDomainNotInitilized(domain, repiDomain.products))
            return [];

        const filteredProducts = [
            { value: "0", shortening: "" },
            ...domain[repiDomain.products].requestResult.filter(f => parseInt(f.value) !== 11)
        ];

        return filteredProducts.map(p => ({
            value: parseInt(p.value),
            label: p.value === "0" ? "" : this.props.translate(`Repi.ProductType.${p.value}`),
            code: p.shortening
        })).sort((a, b) => (a.value > b.value) ? 1 : -1);
    }

    getCurrencySelectOptions = () => {
        const domain = this.props.domain;
        if (repiDomainNotInitilized(domain, repiDomain.currencies))
            return [];

        return domain[repiDomain.currencies].requestResult.filter(f => ["CZK", "EUR"].includes(f.shortening)).map(c => ({
            value: c.shortening,
            label: c.shortening,
            code: c.shortening
        })).sort((a, b) => (a.code > b.code) ? 1 : -1);
    }

    shouldFilterValueByProductCategory= (pc, key) => {
        if (pc === 3 && key === repiAddContractFields.remainingAmount)
            return true;

        if (pc !== 2 && (key === repiAddContractFields.creditorId || key === repiAddContractFields.recallDate || key === repiAddContractFields.productOriginal))
            return true;

        return false;
    }

    displayValidationDetails = () => {
        this.props.showPopup("repiAddSubjectValidationErrorsPopup", {
            open: true,
            close: () => { this.props.hidePopup() },
            data: {
                errors: this.state.validationErrors,
                warnings: this.state.validationWarnings,
            }
        });
    }

    getErrorMessageByState = () => {
        if (this.state.checkFailed)
            return "Repi.DataCorrection.AddContract.InvalidSubjectId";
        if (this.state.checkError)
            return "UnhappyUser.InternalServerError";
        if (this.state.contractExists)
            return "Repi.DataCorrection.AddContract.ContractExists";
        return null;
    }
}

const Input = ({name, label, formik, isDate = false, disabled = false, isRequired = false, noMaxDate = false}) => {
    return (
        <div className="column is-6">
            <RepiSearchInput name={name} label={label} formik={formik} isDate={isDate} disabled={disabled} isRequired={isRequired} noMaxDate={noMaxDate} />
        </div>
    );
}

const Warning = (props) => {
    return (
        <div className="error-container error-container-wide" style={{ paddingBottom: "0.8em", paddingTop: "1em" }}>
            <Message type={props.type} message={props.children} />
        </div>
    )
}

export default connect(
    state => ({ userLaguage: state.userContext.language, domain: state.domain }),
    dispatch => bindActionCreators({ ...domainActions, ...repiActions, ...windowActions, ...popupActions }, dispatch),
)(withLocalize(RepiAddContractForm));
